export default function Footer() {
  const linkGroups = [
    {
      title: '内容导航',
      links: [
        { label: '焦点专题', href: '#carousel' },
        { label: '热门榜单', href: '#ranking' },
        { label: '精选专题', href: '#cards' },
        { label: '话题广场', href: '#topics' },
        { label: '主题索引', href: '#index' },
      ],
    },
    {
      title: '平台信息',
      links: [
        { label: '关于我们', href: '#about' },
        { label: '平台特色', href: '#features' },
        { label: '移动端', href: '#app' },
        { label: '最新动态', href: '#updates' },
        { label: '联系我们', href: '#contact' },
      ],
    },
    {
      title: '帮助支持',
      links: [
        { label: '常见问答', href: '#faq' },
        { label: '用户评论', href: '#comments' },
        { label: '视频精选', href: '#media' },
        { label: '回到顶部', href: '#hero' },
      ],
    },
    {
      title: '合作伙伴',
      links: [],
      placeholder: true,
    },
  ];

  return (
    <footer id="footer" className="w-full bg-background-900 text-white">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          {linkGroups.map((group, i) => (
            <div key={i}>
              <h4 className="font-heading text-base font-bold text-white mb-4">{group.title}</h4>
              {group.placeholder ? (
                <p className="text-sm text-white/40 leading-relaxed">
                  虚位以待，诚邀优质平台合作入驻。
                </p>
              ) : (
                <ul className="space-y-2.5">
                  {group.links.map((link, j) => (
                    <li key={j}>
                      <a
                        href={link.href}
                        className="text-sm text-white/50 hover:text-primary-400 transition-colors"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-center sm:text-left">
            <span className="font-heading text-xl font-extrabold text-white">黑料视频</span>
            <p className="text-xs text-white/40 mt-1.5 max-w-sm">
              体内精69xxxxx黑料社旗下24小时不打烊黑料社区平台。最新黑料视频合集免费在线看，黑料社区持续更新中。
            </p>
          </div>

          <div className="flex items-center gap-4 text-white/40 text-xl">
            <a href="#hero" className="hover:text-primary-400 transition-colors cursor-pointer w-8 h-8 flex items-center justify-center">
              <i className="ri-weibo-line" />
            </a>
            <a href="#hero" className="hover:text-primary-400 transition-colors cursor-pointer w-8 h-8 flex items-center justify-center">
              <i className="ri-wechat-line" />
            </a>
            <a href="#hero" className="hover:text-primary-400 transition-colors cursor-pointer w-8 h-8 flex items-center justify-center">
              <i className="ri-telegram-line" />
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-6 text-center">
          <p className="text-xs text-white/30">
            &copy; {new Date().getFullYear()} 黑料视频 · 体内精69xxxxx黑料社 · 本站内容仅供信息参考，不构成任何建议。
          </p>
        </div>
      </div>
    </footer>
  );
}